import React, { SelectHTMLAttributes } from 'react';

import styled from 'styled-components';

interface SSelectProps {
  $maxWidth?: number;
}

const SSelect = styled.select<SSelectProps>`
  width: 100%;
  max-width: ${(props) => (props.$maxWidth ? `${props.$maxWidth}px` : 'initial')};
  border: 1px solid ${(props) => props.theme.ui.input.borderColor};
  border-radius: 4px;
  font-size: 15px;
  height: 44px;
  padding: 0px 16px;
  outline: none;
  background-color: ${(props) => props.theme.global.bgColor};
  color: ${(props) => props.theme.global.textColor};

  &:focus {
    border: 1px solid ${(props) => props.theme.global.mainColor};
  }

  &:disabled {
    background-color: ${(props) => props.theme.ui.input.disabledBgColor};
  }
`;

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  children?: React.ReactNode;
  maxWidth?: number;
}

const Select = React.forwardRef(
  ({ children, maxWidth, ...rest }: SelectProps, ref: React.ForwardedRef<HTMLSelectElement>) => {
    return (
      <SSelect ref={ref} $maxWidth={maxWidth} {...rest}>
        {children}
      </SSelect>
    );
  }
);

export default Select;
